export default __webpack_public_path__ + "static/media/3.47040555.png";